// extracted by mini-css-extract-plugin
export default {"filledButtonLinkFix":"confirmation_filledButtonLinkFix__491BW","message":"confirmation_message__i-ONE"};